/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum MaritalStatusType {
  Single = 'Single',
  Married = 'Married',
  Divorced = 'Divorced',
  Widowed = 'Widowed',
  Separated = 'Separated',
  DomesticPartner = 'DomesticPartner'
}
